import React from 'react';
import withNuiIntl from '../utils/withNuiIntl';
import compose from '../utils/compose';
import withStylesLoaded from '../utils/withStylesLoaded';
import Footer from './_Footer';

// this wrapper component is necessary to wrap the component
// in a ThemeProvider (handled in withStylesLoaded)
const AppFooter = (props) => <Footer {...props} />;

AppFooter.displayName = 'AppFooter';

AppFooter.propTypes = {
    ...Footer.propTypes,
};

export default compose(
    withStylesLoaded,
    withNuiIntl,
)(AppFooter);
